import { Route, Routes, Navigate } from "react-router-dom";
import Orders from "./Orders";
import Shipping from "./Shipping";
import Profile from "./Profile";
import Showprofile from "./Profile/Showprofile";
import Comments from "./Comments";
import Report from "./Reports";
import ReportOrder from "./Reports/ReportOrder";
import OrderDetails from "./Reports/OrderDetails";
import ReportPenalty from "./Reports/ReportPenalty";
import ReportArchive from "./Reports/ReportArchive";
import ReportScore from "./Reports/ReportScore";
import Food from "./Food";
import Estimate from "./Estimate";

function PrivateRoute() {
  return (
    <Routes>
      <Route path="/" element={<Orders />} />
      <Route path="/shipping" element={<Shipping />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/profile/show" element={<Showprofile />} />
      <Route path="/profile/comments" element={<Comments />} />
      <Route path="/profile/estimate" element={<Estimate />} />
      <Route path="/report" element={<Report />} />
      <Route path="/report/penalty" element={<ReportPenalty />} />
      <Route path="/report/archive" element={<ReportArchive />} />
      <Route path="/report/score" element={<ReportScore />} />
      <Route path="/report/order" element={<ReportOrder />} />
      <Route path="/report/order/details" element={<OrderDetails />} />
      <Route path="/profile/food" element={<Food />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default PrivateRoute;